<template>
    <div id='basic-mixin'></div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      setForceWebViewStatus: 'settings/setForceWebViewStatus'
    }),
    setForceWebView() {
      // const headViewport = document.querySelector('head meta[name="viewport"]');
      // const headViewportContentApp =
      //   'width=device-width,initial-scale=0.1, user-scalable=yes';
      // headViewport.setAttribute('content', headViewportContentApp);
      // this.setForceWebViewStatus(true);
    },
    disableForceWebView() {
      // const headViewport = document.querySelector('head meta[name="viewport"]');
      // const headViewportContentLanding =
      //   'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=5.0, user-scalable=yes"';
      // headViewport.setAttribute('content', headViewportContentLanding);
      // this.setForceWebViewStatus(false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/mixins/BasicMixin.vue